module.exports = __webpack_public_path__ + "static/media/solutions-icon-3.020d93a4.svg";